import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userName:sessionStorage.getItem('zhizhongCurrentUser')
  },
  mutations: {
    saveCurrentUser(state,user){
      state.userName = user
      sessionStorage.setItem('zhizhongCurrentUser',user)
    },
    delCurrentUser(state){
      state.userName = ''
      sessionStorage.setItem('zhizhongCurrentUser','')
    }
  },
  actions: {
  },
  modules: {
  }
})
